// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- HS Code
import {
  TokenValidationErrorTypes,
  RespondentValidationStages,
  RespondentTokenValidationModel,
} from '../../../models';
import { RespondentValidationBaseService } from './respondent-validation-base.service';
import { OidcService } from '../account/oidc.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class RespondentValidationMockService extends RespondentValidationBaseService {
  constructor(oidcService: OidcService) {
    super(oidcService);
  }

  validateRespondentToken(token: string): void {
    of(token)
      .pipe(delay(5000))
      .subscribe((result) => {
        if (result === 'error') {
          this._validationStage$.next(RespondentValidationStages.tokenError);
          this._respondentValidation$.next({
            tokenValue: '',
            hasPassword: false,
            tokenValidationErrorType: TokenValidationErrorTypes.unexpectedError,
            locale: '',
            applicationError: {
              errorMessage: 'errorHeaderUnexpected',
              detailedMessage: 'respondentValidationUnexpectedError',
            },
          } as RespondentTokenValidationModel);
          return;
        }
        this._authenticateFromOtac('');
      });
  }
}
